import { useState, useEffect } from 'react'
import { useConfessions } from '../hooks/useConfessions.js'
import { useHiddenPosts } from '../hooks/useHiddenPosts.js'
import ConfessionCard from '../components/ConfessionCard.jsx'

// Öffentliche Basis-URL für geteilte Links. In der Capacitor-App ist der
// eigene Origin nur https://localhost, dann wird ohne VITE_PUBLIC_URL nicht geteilt.
const PUBLIC_URL = (import.meta.env.VITE_PUBLIC_URL || '').replace(/\/$/, '')
const isAppOrigin = ['localhost', '127.0.0.1'].includes(window.location.hostname) && window.location.port === ''

export function postUrl(slug) {
  const base = PUBLIC_URL || (isAppOrigin ? '' : window.location.origin)
  return base ? `${base}/p/${slug}` : null
}

// Einzelansicht eines Posts (/p/<slug>), liegt als Vollbild über dem Feed,
// damit beim Zurückgehen die Scrollposition im Feed erhalten bleibt.
export default function PostPage({ slug, onClose, onPin }) {
  const { hiddenIds, toggleHidden } = useHiddenPosts()
  const { confessions, loading, error, vote, judge, pray, report } = useConfessions('new', '', [], slug)
  const [copied, setCopied] = useState(false)
  const confession = confessions[0]
  const link = postUrl(slug)

  // Feed dahinter nicht mitscrollen
  useEffect(() => {
    const prev = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => { document.body.style.overflow = prev }
  }, [])

  async function handleShare() {
    if (!link) return
    try {
      if (navigator.share) {
        await navigator.share({ title: 'Reverend', url: link })
        return
      }
      await navigator.clipboard.writeText(link)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch { /* Teilen abgebrochen */ }
  }

  return (
    <div className="post-page" role="dialog" aria-modal="true" aria-label="Confession">
      <div className="post-page-bar">
        <button className="post-page-back" onClick={onClose} aria-label="Back to feed">←</button>
        <span className="post-page-title">Confession</span>
        {link && confession && (
          <button className="post-page-share" onClick={handleShare}>
            {copied ? 'Link copied ✓' : 'Share'}
          </button>
        )}
      </div>

      <div className="post-page-content">
        {loading && <div className="feed-state"><div className="spinner" aria-label="Loading…" /></div>}
        {!loading && error && (
          <div className="feed-state feed-error" role="alert">
            {error}
            <div><button className="btn btn-primary post-page-home" onClick={onClose}>Go to feed</button></div>
          </div>
        )}
        {!loading && !error && confession && (
          <ConfessionCard
            confession={confession}
            onVote={vote}
            onJudge={judge}
            onPray={pray}
            onReport={report}
            onPin={onPin}
            hidden={hiddenIds.includes(confession.id)}
            showWhenHidden
            onToggleHidden={toggleHidden}
            defaultCommentsOpen
          />
        )}
      </div>
    </div>
  )
}
